import React, { useEffect, useState } from "react";

function MarksCard(props) {
  const { sno, student } = props;

  const [editedMarks, setEditedMarks] = useState(
    student.student_type_data[0].marks_obtained
  );
  const [studentPercentage, setStudentPercentage] = useState(
    student.student_type_data[0].percentage
  );
  const [grade, setGrade] = useState("");
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(
    student.student_type_data[0].attendence
  );

  const handleMarksChange = (event) => {
    const marks = event.target.value;
    const maxMarks = student.student_type_data[0].exam__max_marks;
    props.onChangeMarks(Number(sno), Number(marks));
    if (marks <= maxMarks && marks >= 0) setEditedMarks(marks);
    const percentage = (marks / maxMarks) * 100;
    setStudentPercentage(percentage);
  };
  const handleCheckboxChange = (event) => {
    props.onChangeAttendanceStatus(Number(sno), event.target.checked);
    setIsCheckboxChecked(!isCheckboxChecked);
  };

  useEffect(() => {
    if (props.gradingData.length !== 0) {
      const gradee = props.gradingData.find(
        (grade) => grade.min_percentage < studentPercentage
      );
      setGrade(gradee?.grade);
    }
  }, [editedMarks, props]);

  return (
    <div className="my-4">
      <div
        className="flex-column w-100 p-2  my-3 th-br-10"
        style={{
          boxShadow: "0px 1px 3px  grey",
        }}
      >
        <div className="d-flex justify-content-between th-fw-600 pb-2">
          <div className="th-12 text-center  pt-1 ">
            Name <br />
            <div className="th-fw-600 th-primary">
              {student.user__first_name}
            </div>
          </div>
          <div className="th-12 text-center  pt-1 ">
            Roll No. <br />{" "}
            <div className="th-fw-600 th-primary">{student.roll_no}</div>
          </div>
        </div>
        <div className="d-flex justify-content-between th-fw-600 pb-2">
          <div className="th-12 text-center  pt-1 ">
            Username <br />{" "}
            <div className="th-fw-600 th-primary">
              {" "}
              {student.user__username}
            </div>
          </div>
          <div className="th-12 text-center  pt-1 ">
            Admission No. <br />{" "}
            <div className="th-fw-600 th-primary">
              {student.student__admission_no}
            </div>
          </div>
        </div>
        <div className="th-12 text-center pt-1 ">
          <div className="th-fw-600">
            {student.student_type_data[0].subject} (MM{" "}
            {student.student_type_data[0].exam__max_marks}){" "}
          </div>
          <div className="d-flex justify-content-center mx-auto ">
            <input
              type="checkbox"
              checked={isCheckboxChecked}
              onChange={handleCheckboxChange}
              style={{ width: 18 }}
              className="th-input-primary mr-3"
            />
            <input
              className="my-2 th-input-primary th-br-6 py-1 text-center"
              style={{ width: "45px" }}
              value={editedMarks}
              onChange={handleMarksChange}
              type="number"
              max={student.student_type_data[0].exam__max_marks}
              min={0}
              disabled={!isCheckboxChecked}
            ></input>
            <span className="my-auto th-primary th-fw-600 ml-3">{grade}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MarksCard;
